"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getTimezoneOffset;
function getTimezoneOffset() {
  var tzOffsetMin = new Date().getTimezoneOffset();
  var offsetH = parseInt(Math.abs(tzOffsetMin / 60), 10);
  var offsetM = Math.abs(tzOffsetMin % 60);
  var tzStandard;
  if (offsetH < 10) {
    offsetH = '0' + offsetH;
  }
  if (offsetM < 10) {
    offsetM = '0' + offsetM;
  }

  // Add an opposite sign to the offset
  // If offset is 0, it means timezone is UTC
  if (tzOffsetMin < 0) {
    tzStandard = '+' + offsetH + ':' + offsetM;
  } else if (tzOffsetMin > 0) {
    tzStandard = '-' + offsetH + ':' + offsetM;
  } else if (tzOffsetMin === 0) {
    tzStandard = 'Z';
  }
  return tzStandard;
}